<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Empresas"
          icon="fas fa-coins"
          btn_name="Empresa"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          @mtd_deploy="mtd_deploy"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="true"
          :myButtons="myButtons"
          @mtd_roles="mtd_roles"
          @mtdInstance="mtdInstance"
          @mtdRecording="mtdRecording"
        />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'xl'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="3">
          <CInput
            label="RUC"
            placeholder="Digite RUC"
            v-model="companies.ruc"
            maxlength="11"
            @input="validateRUC"
            @keyup.enter="mtdSearchDocument"
            v-on:keypress="isNumber($event)"
          />
          <span v-if="errors.ruc" class="text-danger">{{ errors.ruc }}</span>
        </CCol>
        <CCol sm="9">
          <CInput
            label="Razón social"
            placeholder="Digite Razón social"
            v-model="companies.name"
          />
        </CCol>
        <CCol sm="3">
          <!-- <cSelectForm label="Tipo de empresa" placeholder="Seleccione tipo de empresa" :options="data_type_company"
            :value.sync="companies.type_company" :disabled="this.$store.getters.get_all_user.id !== 1" /> -->
          <CInput
            label="Fecha de culminación"
            type="date"
            :min="today"
            v-model="companies.completion_date"
          />
        </CCol>
        <CCol sm="3">
          <CInput
            label="Telefono"
            placeholder="Digite Telefono"
            v-model="companies.phone"
            maxlength="9"
            @input="validatePhone"
          />
          <span v-if="errors.phone" class="text-danger">{{
            errors.phone
          }}</span>
        </CCol>
        <CCol sm="6">
          <CInput
            label="Correo"
            placeholder="Digite Correo"
            v-model="companies.email"
            @input="validateEmail(companies.email)"
            type="email"
          />
          <span v-if="errors.email_company" class="text-danger">{{
            errors.email_company
          }}</span>
        </CCol>
        <CCol sm="4">
          <div class="mb-2">¿Desea apertura y cierre de caja?</div>
          <CSwitchVue
            @changeSwitch="handleSwitchChange"
            v-model="companies.box"
            color="success"
            variant="opposite"
            shape="pill"
            class=""
            :checked="companies.box == 1"
            v-bind="labelIcon"
          />
        </CCol>
        <CCol sm="4">
          <div class="mb-2">¿Realiza devolucion de dinero?</div>
          <CSwitchVue
            @changeSwitch="handleSwitchChangeDevolution"
            v-model="companies.devolution"
            color="success"
            variant="opposite"
            shape="pill"
            class=""
            :checked="companies.devolution == 1"
            v-bind="labelIcon"
          />
        </CCol>
        <CCol sm="4">
          <div class="mb-2">Logo</div>
          <input
            @change="getFile"
            type="file"
            class="form-control"
            id="file"
            lang="es"
            name="file"
            ref="fileInput"
            accept=".png,.jpg,.jpeg"
          />
          <div
            v-if="companies.logo && modal.action !== 'store'"
            class="container-img"
          >
            <img
              v-if="typeof companies.logo === 'string' && companies.logo"
              :src="'https://mybarber.howertpi.com/assets/' + companies.logo"
              class="img-thumbnail"
              style="max-width: 100px"
              alt="Company Logo"
            />
            <p v-else></p>
          </div>
        </CCol>
        <CCol sm="12">
          <label
            v-if="modal.action === 'store'"
            class="mt-3 mb-2 font-lg font-weight-bold"
            >Datos del Representante</label
          >
        </CCol>
        <CCol sm="6">
          <CInput
            v-if="modal.action === 'store'"
            label="Nombre"
            placeholder="Digite nombre del representante"
            v-model="barbers.name"
            @input="ValidateName"
          />
          <span v-if="errors.name" class="text-danger">{{ errors.name }}</span>
        </CCol>
        <CCol sm="6">
          <CInput
            v-if="modal.action === 'store'"
            label="Apellido"
            placeholder="Digite apellido del representante"
            v-model="barbers.last_name"
            @input="ValidateLastName"
          />
          <span v-if="errors.last_name" class="text-danger">{{
            errors.last_name
          }}</span>
        </CCol>
        <CCol sm="3">
          <CSelect
            v-if="modal.action === 'store'"
            label="Tipo de documento"
            :value.sync="barbers.document_type"
            :options="type_documents"
            placeholder="--Seleccione un documento--"
            @change="onDocumentTypeChange"
          />
        </CCol>
        <CCol sm="3">
          <CInput
            v-if="modal.action === 'store'"
            label="Número de documento"
            placeholder="Digite número de documento"
            v-model="barbers.dni"
            :maxlength="documentMaxLength"
            :disabled="!barbers.document_type"
            @input="validateDocument"
          />
          <span
            v-if="modal.action === 'store' && errors.dni"
            class="text-danger"
            >{{ errors.dni }}</span
          >
        </CCol>
        <CCol sm="3">
          <CInput
            v-if="modal.action === 'store'"
            label="Telefono"
            placeholder="Digite Telefono"
            v-model="barbers.phone"
            @input="validatePhoneEmployee"
            maxlength="9"
          />
          <span
            v-if="modal.action === 'store' && errors.phone_barber"
            class="text-danger"
            >{{ errors.phone_barber }}</span
          >
        </CCol>
        <CCol sm="3">
          <CInput
            v-if="modal.action === 'store'"
            label="Correo"
            placeholder="Digite Correo"
            type="email"
            @input="validateEmail(barbers.email)"
            v-model="barbers.email"
          />
          <span
            v-if="modal.action === 'store' && errors.email_barber"
            class="text-danger"
            >{{ errors.email_barber }}</span
          >
        </CCol>

        <CCol sm="3">
          <CInput
            label="Precio por boleta"
            placeholder="00.000"
            min="0"
            step="0.001"
            type="number"
            v-model="companies.unit_price"
            :disabled="isMonthlyPriceSet"
            @change="handleUnitPriceChange"
          />
        </CCol>

        <CCol sm="3">
          <CInput
            label="Precio mensual de boletas"
            placeholder="00.000"
            min="0"
            step="0.001"
            type="number"
            v-model="companies.monthly_price"
            :disabled="isUnitPriceSet"
            @change="handleMonthlyPriceChange"
          />
        </CCol>

        <CCol sm="3">
          <CInput
            label="Precio Proveedor"
            placeholder="00.000"
            min="0"
            step="0.001"
            type="number"
            v-model="companies.provider_price"
          />
        </CCol>
        <CCol
          v-if="modal.action != 'store'"
          sm="12"
          lg="3"
          xl="3"
          xxl="3"
          xs="12"
          class="pt-2"
        >
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="companies.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Empresa'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />

    <cModalAddRolesVue
      @mtd_closeAddRoles="mtd_closeAddRoles"
      :boo_modal="modalAddRoles.modal_form"
      :title="modalAddRoles.title"
      :id_company="modalAddRoles.id_company"
      :item="modalAddRoles.item"
    />
    <cModalWsp
      @mtdCloseModalWsp="mtdCloseModalWsp"
      :boo_modal="modalWsp.modal_form"
      :title="modalWsp.title"
      :id_company="modalWsp.id_company"
      :item="modalWsp.item"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  // { key: "ruc", label: "RUC", _style: "width:10%;" },
  { key: "name", label: "Razón Social", _style: "width:10%;" },
  { key: "phone", label: "Teléfono", _style: "width:10%;" },
  // { key: "email", label: "Correo", _style: "width:10%;" },
  {
    key: "completion_date",
    label: "Fecha de culminación",
    _style: "width:10%;",
  },
  { key: "environment", label: "Estado de facturación", _style: "width:10%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
  // { key: "type_company", label: "Tipo de empresa", _style: "width:5%;" },
];

import CTableWrapper from "../../components/shared/datatable/Table.vue";
import CModalForm from "../../components/shared/modals/cModalForm.vue";
import cModalDelete from "../../components/shared/modals/cModalDelete.vue";
import cModalAddRolesVue from "./modals/cModalAddRoles.vue";
import { mapActions } from "vuex";
// import { CCol, CSwitch } from "@coreui/vue-pro";
import CSwitchVue from "../shared/switch/CSwitch.vue";
// import cSelectForm from "../../components/shared/inputs/cSelect.vue";
// import CSelect from "../../components/shared/inputs/cSelect.vue";
import moment from "moment";
import cModalWsp from './modals/cModalWsp.vue';

export default {
  components: {
    CTableWrapper,
    CModalForm,
    cModalDelete,
    CSwitchVue,
    cModalAddRolesVue,
    cModalWsp
    // cSelectForm,
  },
  data() {
    return {
      prefix: "companies",
      today: null,
      fields,
      type_documents: ["DNI", "PASAPORTE", "CARNET EXTRANJERÍA", "RUC"],
      data: [],
      myButtons: [
        {
          class: "btn-sm",
          color: "dark",
          tooltip: "Agregar Roles",
          action: "mtd_roles",
          icon: "fas fa-solid fa-user",
        },
        {
          class: "btn-sm",
          color: "warning",
          tooltip: "pasar a modo deploy",
          action: "mtd_deploy",
          icon: "fas fa-solid fa-rocket",
        },
        {
          class: "btn-sm",
          color: "success",
          tooltip: "Instancia de wsp",
          action: "mtdInstance",
          icon: "fab fa-whatsapp",
        },
        {
          class: "btn-sm",
          color: "info",
          tooltip: "Mensajes de recordatorio",
          action: "mtdRecording",
          icon: "fas fa-calendar",
        }
      ],
      modalAddRoles: {
        title: "",
        modal_form: false,
        item: {},
        id_company: 0,
      },
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      data_type_company: [
        { value: 1, label: "BARBERIA" },
        { value: 2, label: "VETERINARIA" },
      ],
      companies: {
        id: "",
        name: "",
        completion_date: "",
        ruc: "",
        phone: "",
        email: "",
        logo: "",
        state: 0,
        // type_company: "",
        box: 0,
        devolution: 0,
        unit_price: 0,
        monthly_price: 0,
        provider_price: 0,
      },
      barbers: {
        id: "",
        name: "",
        last_name: "",
        document_type: "",
        dni: "",
        phone: "",
        email: "",
        state: 0,
      },
      errors: {
        ruc: "",
        phone: "",
        dni: "",
        phone_barber: "",
        email_company: "",
        email_barber: "",
        last_name: "",
        name: "",
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      documentMaxLength: 8,
      /** modal wsp */
      modalWsp: {
        title: "",
        modal_form: false,
        item: {
          id:0,
          instance_name:"",
          instance_id:"",
          conected:"",
          state:""
        },
      },
    };
  },
  computed: {
    isUnitPriceSet() {
      return this.companies.unit_price > 0;
    },

    isMonthlyPriceSet() {
      return this.companies.monthly_price > 0;
    },

    cpStatus: function () {
      if (this.companies.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (this.modal.action == "store") {
        if (
          this.companies.name !== "" &&
          this.companies.ruc !== "" &&
          this.companies.phone !== "" &&
          this.companies.email !== "" &&
          (this.companies.unit_price > 0 || this.companies.monthly_price > 0) &&
          this.companies.provider_price !== "" &&
          this.barbers.name !== "" &&
          this.barbers.last_name !== "" &&
          this.barbers.dni !== "" &&
          this.barbers.email !== "" &&
          this.errors.email_company == "" &&
          this.errors.email_barber == "" &&
          this.errors.name == "" &&
          this.errors.last_name == ""
        )
          return false;
        return true;
      }
      if (this.modal.action == "update") {
        if (
          this.companies.name !== "" &&
          this.companies.ruc !== "" &&
          this.companies.phone !== "" &&
          this.companies.email !== "" &&
          this.errors.email_company == "" &&
          (this.companies.unit_price > 0 || this.companies.monthly_price > 0) &&
          this.companies.provider_price !== ""
        )
          return false;
        return true;
      }
    },
  },
  watch: {
    "companies.unit_price": {
      handler(newValue) {
        if (newValue === "" || newValue < 0) {
          this.companies.unit_price = 0;
        }
      },
    },
    "companies.monthly_price": {
      handler(newValue) {
        if (newValue === "" || newValue < 0) {
          this.companies.monthly_price = 0;
        }
      },
    },
  },
  created() {
    this.mtd_getdata();
  },
  methods: {
    ...mapActions(["get", "post"]),
    handleUnitPriceChange(value) {
      let numValue = parseFloat(value) || 0;
      if (numValue < 0) numValue = 0;
      this.companies.unit_price = numValue;
      if (numValue > 0) {
        this.companies.monthly_price = 0;
      }
    },
    handleMonthlyPriceChange(value) {
      let numValue = parseFloat(value) || 0;
      if (numValue < 0) numValue = 0;
      this.companies.monthly_price = numValue;
      if (numValue > 0) {
        this.companies.unit_price = 0;
      }
    },
    mtd_roles: function (item) {
      this.modalAddRoles = {
        title: "Agregar Roles",
        modal_form: true,
        id_company: item.Id,
        item: item,
      };
    },
    mtd_closeAddRoles: function () {
      this.modalAddRoles.modal_form = false;
    },
    handleSwitchChange(payload) {
      this.companies.box = payload ? 1 : 0;
    },
    handleSwitchChangeDevolution(payload) {
      this.companies.devolution = payload ? 1 : 0;
    },
    getFile(e) {
      let fileInput = this.$refs.fileInput;
      let file = e.target.files[0];
      if (
        !/\.(png)$/i.test(file.name) &&
        !/\.(jpg)$/i.test(file.name) &&
        !/\.(jpeg)$/i.test(file.name)
      ) {
        fileInput.value = "";
      } else {
        this.companies.logo = file;
      }
    },
    mtd_getdata: function () {
      this.get({
        url: this.$store.getters.get__url + "/companies/index",
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.data = response.data.data;
        let index = 1;
        this.data.forEach((arr) => {
          arr.index = index;
          index++;
        });
        this.today = moment().format("YYYY-MM-DD");
        this.companies.completion_date = this.today;
      });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nueva Empresa")
        : (this.modal.title = "Editar Empresa");
      if (action == "store") {
        this.companies = {
          id: "",
          name: "",
          completion_date: "",
          ruc: "",
          phone: "",
          email: "",
          logo: "",
          // type_company: "",
          state: 0,
          box: 0,
          devolution: 0,
          unit_price: 0,
          monthly_price: 0,
          provider_price: 0,
        };
        this.barbers = {
          id: "",
          name: "",
          last_name: "",
          dni: "",
          phone: "",
          // address: "",
        };
        this.errors = {
          ruc: "",
          phone: "",
          dni: "",
          phone_barber: "",
          email_company: "",
          email_barber: "",
        };
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
      } else {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
        this.companies = this.companies;
        this.barbers = this.barbers;
        this.errors = {
          ruc: "",
          phone: "",
          dni: "",
          phone_barber: "",
          email_company: "",
          email_barber: "",
        };
      }
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_deploy: function (item) {
      const stateEnvironment = item.environment;
      const newEnvironment =
        stateEnvironment === "local" ? "production" : "local";
      const actionText =
        stateEnvironment === "local"
          ? "cambiar a producción"
          : "cambiar a local";
      Swal.fire({
        title: "¿Estás seguro?",
        html: `¿Deseas ${actionText} las facturas para <strong>${item.name}</strong>?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        denyButtonColor: "#cfc83d",
        confirmButtonText: "Sí, sin reinicio",
        cancelButtonText: "Cancelar",
        showDenyButton: true,
        denyButtonText: "Sí, con reinicio",
      }).then((result) => {
        if (result.isConfirmed) {
          this.post({
            url:
              this.$store.getters.get__url +
              "/" +
              this.prefix +
              "/deploy/" +
              item.Id,
            token: this.$store.getters.get__token,
            params: {
              environment: newEnvironment,
              reset_correlatives: false,
            },
          }).then((response) => {
            if (response.statusCode == 200) {
              Swal.fire(
                "¡Completado!",
                `Las facturas han sido cambiadas a ${newEnvironment}`,
                "success"
              );
              this.mtd_getdata();
            }
          });
        } else if (result.isDenied) {
          this.post({
            url:
              this.$store.getters.get__url +
              "/" +
              this.prefix +
              "/deploy/" +
              item.Id,
            token: this.$store.getters.get__token,
            params: {
              environment: newEnvironment,
              reset_correlatives: true,
            },
          }).then((response) => {
            if (response.statusCode == 200) {
              Swal.fire(
                "¡Completado!",
                `Las facturas han sido cambiadas a ${newEnvironment} y se reiniciaron los correlativos`,
                "success"
              );
              this.mtd_getdata();
            }
          });
        }
      });
    },
    mtd_action: function () {
      if (!this.validateForm()) return;

      let formData = new FormData();
      // formData.append("company", this.$store.getters.get_company);
      formData.append("id", this.companies.id);
      formData.append("completion_date", this.companies.completion_date);
      formData.append("name", this.companies.name);
      formData.append("ruc", this.companies.ruc);
      formData.append("phone", this.companies.phone);
      formData.append("email", this.companies.email);
      formData.append("logo", this.companies.logo);
      formData.append("box", this.companies.box);
      formData.append("devolution", this.companies.devolution);
      formData.append("unit_price", this.companies.unit_price);
      formData.append("monthly_price", this.companies.monthly_price);
      formData.append("provider_price", this.companies.provider_price);

      // formData.append("type_company", this.companies.type_company);
      formData.append("state", this.companies.state);
      if (this.modal.action === "store") {
        formData.append("barber_name", this.barbers.name);
        formData.append("completion_date", this.companies.completion_date);
        formData.append("barber_last_name", this.barbers.last_name);
        formData.append("document_type", this.barbers.document_type);
        formData.append("barber_dni", this.barbers.dni);
        formData.append("barber_email", this.barbers.email);
        formData.append("barber_phone", this.barbers.phone);
      }
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: formData,
      })
        .then((response) => {
          if (
            response.data.state == 1 ||
            response.data.state == 2 ||
            response.data.state == 3 ||
            response.data.state == 4
          ) {
            if (response.data.state == 1) {
              Swal.fire({
                title: "RUC ya resgistrado",
                icon: "warning",
              });
            } else if (response.data.state == 2) {
              Swal.fire({
                title: "DNI ya resgistrado",
                icon: "warning",
              });
            } else if (response.data.state == 3) {
              Swal.fire({
                title: "Email de la Compañia ya resgistrado",
                icon: "warning",
              });
            } else {
              Swal.fire({
                title: "Email del Representante ya resgistrado",
                icon: "warning",
              });
            }
          } else {
            let color = "success";
            let message = "";
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
              this.mtd_getdata();
            } else {
              let updatedCompany = response.data.data.company;
              let updatedEmployee = response.data.data.employee;
              let index = this.data.findIndex(
                (company) => company.id === updatedCompany.id
              );
              if (index !== -1) {
                this.$set(this.data, index, {
                  ...updatedCompany,
                  ...updatedEmployee,
                });
              }
              message = "EDITADO CORRECTAMENTE";
              this.mtd_getdata();
            }
            this.modal = {
              action: "",
              title: "",
              modal_form: false,
              name: "",
            };
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.errors.ruc = "";
          this.errors.phone = "";
          this.errors.dni = "";
          this.errors.phone_barber = "";

          this.companies = response;
          if (this.companies.logo) {
            let url_logo = this.companies.logo;
            let url = this.$store.getters.get__url;
            let urlModifie = url.replace("api/v1", "");
            this.companies.logo = url_logo.replace(
              "http://localhost/",
              urlModifie
            );
          } else {
            this.companies.logo = "";
          }

          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          this.mtd_getdata();
          this.modal_delete = {
            boo: false,
            item: [],
          };

          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => {});
    },
    validateRUC() {
      if (this.companies.ruc.length != 11 || isNaN(this.companies.ruc)) {
        this.errors.ruc = "El RUC debe ser un número de máximo 11 dígitos";
      } else {
        this.errors.ruc = "";
      }
    },
    ValidateName() {
      const regex = /^[A-Za-z\s]+$/;
      if (!regex.test(this.barbers.name)) {
        this.errors.name = "El nombre solo puede contener letras y espacios";
      } else {
        this.errors.name = "";
      }
    },
    ValidateLastName() {
      const regex = /^[A-Za-z\s]+$/;
      if (!regex.test(this.barbers.last_name)) {
        this.errors.last_name =
          "El apellido solo puede contener letras y espacios";
      } else {
        this.errors.last_name = "";
      }
    },
    validatePhone() {
      if (this.companies.phone.length != 9 || isNaN(this.companies.phone)) {
        this.errors.phone =
          "El teléfono debe ser un número de máximo 9 dígitos";
      } else {
        this.errors.phone = "";
      }
    },
    validateEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (email == this.companies.email) {
        if (!emailPattern.test(email)) {
          this.errors.email_company =
            "El correo electrónico no tiene un formato válido";
        } else {
          this.errors.email_company = "";
        }
      } else if (email == this.barbers.email) {
        if (!emailPattern.test(email)) {
          this.errors.email_barber =
            "El correo electrónico no tiene un formato válido";
        } else {
          this.errors.email_barber = "";
        }
      }
    },
    validatePhoneEmployee() {
      if (this.barbers.phone.length != 9 || isNaN(this.barbers.phone)) {
        this.errors.phone_barber =
          "El teléfono debe ser un número de máximo 9 dígitos";
      } else {
        this.errors.phone_barber = "";
      }
    },
    // getDocumentMaxLength(documentType) {
    //   switch (documentType) {
    //     case 'DNI':
    //       return 8;
    //     case 'RUC':
    //       return 11;
    //     case 'CARNET EXTRANJERÍA':
    //       return 9;
    //     default:
    //       return 20;
    //   }
    // },
    // validateDocumentNumber() {
    //   const documentType = this.barbers.document_type;
    //   const documentNumber = this.barbers.dni;

    //   if (documentType === 'DNI' && (documentNumber.length !== 8 || isNaN(documentNumber))) {
    //     this.errors.dni = "El DNI debe ser un número de 8 dígitos";
    //   } else if (documentType === 'RUC' && (documentNumber.length !== 11 || isNaN(documentNumber))) {
    //     this.errors.dni = "El RUC debe ser un número de 11 dígitos";
    //   } else if (documentType === 'PASAPORTE' && documentNumber.length === 0) {
    //     this.errors.dni = "El número de pasaporte no puede estar vacío";
    //   } else if (documentType === 'CARNET EXTRANJERÍA' && documentNumber.length === 0) {
    //     this.errors.dni = "El número de carnet de extranjería no puede estar vacío";
    //   } else {
    //     this.errors.dni = "";
    //   }
    // },
    onDocumentTypeChange() {
      if (this.barbers.document_type === "DNI") {
        this.documentMaxLength = 8;
      } else if (this.barbers.document_type === "RUC") {
        this.documentMaxLength = 11;
      } else if (this.barbers.document_type === "PASAPORTE") {
        this.documentMaxLength = 15; // Suponiendo que el pasaporte tenga un máximo de 15
      } else if (this.barbers.document_type === "CARNET EXTRANJERÍA") {
        this.documentMaxLength = 9; // Suponiendo que el carnet de extranjería tenga un máximo de 12
      }
    },
    validateDocument() {
      if (
        this.barbers.dni.length !== this.documentMaxLength ||
        isNaN(this.barbers.dni)
      ) {
        this.errors.dni = `El ${this.barbers.document_type} debe tener ${this.documentMaxLength} dígitos y ser un número válido.`;
      } else {
        this.errors.dni = "";
      }
    },
    validateForm() {
      // this.ValidateName();
      // this.ValidateLastName();
      this.validateRUC();
      this.validatePhone();
      this.validateEmail(this.companies.email);
      if (this.modal.action === "store") {
        this.ValidateName();
        this.ValidateLastName();
        // this.validateDocumentNumber();
        this.validatePhoneEmployee();
        this.validateEmail(this.barbers.email);
      }

      return (
        this.errors.ruc === "" &&
        this.errors.phone === "" &&
        this.errors.dni === "" &&
        this.errors.phone_barber === "" &&
        this.errors.email_company === "" &&
        this.errors.email_barber === ""
      );
    },
    changeSwitch: function (payload) {
      this.companies.state = payload == true ? 1 : 0;
    },
    /** helpers */
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    /** buscar documento */
    mtdSearchDocument: function () {
      if (this.companies.ruc.length === 8 || this.companies.ruc.length === 11) {
        this.get({
          url:
            this.$store.getters.get__url + "/Consultas/" + this.companies.ruc,
          token: this.$store.getters.get__token,
        })
          .then((response) => {
            if (response.data.boo === 3) {
              this.companies.name = "";
              Swal.fire({
                title: "Documento no encontrado",
                icon: "warning",
              });
            } else {
              this.populateClientData(response.data);
            }
          })
          .catch((error) => {
            console.error("Error al consultar el documento:", error);
            Swal.fire({
              title: "Error en la solicitud",
              text: "Por favor, intente nuevamente más tarde.",
              icon: "error",
            });
          });
      }
    },
    populateClientData: function (data) {
      if (this.companies.ruc.length === 8) {
        this.companies.name = `${data.name} ${data.last_name}`;
      } else {
        this.companies.name = data.razon_social;
      }
    },
    /** instancias wsp */
    mtdInstance: function(payload){
      this.modalWsp.modal_form=true;
      this.modalWsp.title="Instancia de wsp";
      this.modalWsp.item = payload;
    },
    mtdCloseModalWsp: function(action){
      this.modalWsp.modal_form=false;
      this.modalWsp.item = {
        id:0,
        instance_name:"",
        instance_id:"",
        conected:"",
        state:""
      }
      if (action == 'create') {
        this.mtd_getdata();
      }
    },
    /** activar mensajes automaticos */
    mtdRecording: function(payload){
      const stateRecording = payload.recording_reserve;
      const actionText =
        stateRecording === true
          ? "desactivar"
          : "activar";
      Swal.fire({
        title: "¿Estás seguro?",
        html: `¿Deseas ${actionText} los recordatorios de reservas para <strong>${payload.name}</strong>?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        denyButtonColor: "#cfc83d",
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          this.get({
            url:
              this.$store.getters.get__url +
              "/" +
              this.prefix +
              "/recording/" +
              payload.Id,
            token: this.$store.getters.get__token
          }).then((response) => {
            if (response.statusCode == 200) {
              Swal.fire(
                "¡Completado!",
                `Actualización correcta`,
                "success"
              );
              this.mtd_getdata();
            }
          });
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}

.container-img {
  margin: 10px 0 0 0;
  display: flex;
  justify-content: center;
}
</style>
